import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SearchPriceQuoteItemsDocument = gql`
  query SearchPriceQuoteItems($chatId: uuid!, $query: String!) {
    searchPriceQuoteItems(chat_id: $chatId, query: $query) {
      items {
        variant_pack_id
        item_name
        item_code
        item_description
        item_pack_size
        currency_code
        pack_price_in_micros
        per_unit_price_in_micros
      }
    }
  }
`;
export function useSearchPriceQuoteItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >(SearchPriceQuoteItemsDocument, options);
}
export function useSearchPriceQuoteItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >(SearchPriceQuoteItemsDocument, options);
}
export type SearchPriceQuoteItemsQueryHookResult = ReturnType<
  typeof useSearchPriceQuoteItemsQuery
>;
export type SearchPriceQuoteItemsLazyQueryHookResult = ReturnType<
  typeof useSearchPriceQuoteItemsLazyQuery
>;
export type SearchPriceQuoteItemsQueryResult = Apollo.QueryResult<
  Types.SearchPriceQuoteItemsQuery,
  Types.SearchPriceQuoteItemsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSearchPriceQuoteItemsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSearchPriceQuoteItemsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >(SearchPriceQuoteItemsDocument, options);
}

/**
 * Wrapped version of useGeneratedSearchPriceQuoteItemsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSearchPriceQuoteItemsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SearchPriceQuoteItemsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SearchPriceQuoteItemsQuery,
    Types.SearchPriceQuoteItemsQueryVariables
  >(SearchPriceQuoteItemsDocument, lazyOptions);
}
